// extracted by mini-css-extract-plugin
module.exports = {"SidebarIcon":"sidebar_SidebarIcon__2RQ4I","MenuToggler":"sidebar_MenuToggler__3IHfJ","TogglerIconOpen":"sidebar_TogglerIconOpen__13zQ7","SidebarMenu":"sidebar_SidebarMenu__3iVQU"};